var langSwitcher = {
    init: function() {
        $( 'select[name="lang-switcher"]' ).on( 'change', function() {
            var val = $( this ).val();

            window.location.href = val;
        } );
    }
}

export { langSwitcher };